/* eslint-disable no-restricted-syntax */

/**
 * Aquí se definiran los enums que se utilizan en el módulo de compras
 * para ser más específico, en el flujo de compras.
 */

export const enum OpcionesEntrega {
    DIFERENTE_ESTABLECIMIENTO = 'D',
    MISMO_ESTABLECIMIENTO = 'I',
    POR_DEFINIR = 'PD',
}

export const enum OpcionesFacturacion {
    ESTABLECIMIENTO_SOLICITANTE = 'S',
    ESTABLECIMIENTO_ENTREGA = 'E',
}

export const enum PrioridadSolicitud {
    EMERGENTE = 'emergente',
    PLANIFICADA = 'planificada',
    INMEDIATA = 'inmediata',
}

export const enum TipoArticulo {
    BIEN = 'bien',
    SERVICIO = 'servicio',
}

export const enum TipoSolicitante {
    IPSP = 'ipsp',
    PROVEEDOR_LOCAL = 'proveedor_local',
}

export const enum TipoNaturaleza {
    EVENTUAL = 'eventual',
    RECURRENTE = 'recurrente',
}

export const enum TipoCosto {
    FIJO = 'fijo',
    CONSUMO = 'consumo',
    UNICO = 'unico',
}

export const enum EstadoDocumentos {
    BORRADOR = 'borrador',
    PENDIENTE = 'pendiente',
    APROBADO = 'aprobado',
    RECHAZADO = 'rechazado',
    ANULADO = 'anulado',
    CERRADO = 'cerrado',
    AUTORIZADO = 'autorizado',
}

export const enum EstadoCumplimiento {
    PENDIENTE = 'pendiente',
    PARCIAL = 'parcial',
    COMPLETO = 'completo',
}

export const enum EstadoRecepcion {
    /**
     * Cuando un `doc` es un borrador
     */
    BORRADOR = 'borrador',
    ANULADO = 'anulado',
    PENDIENTE = 'pendiente',
    APROBADO = 'aprobado',
    /**
     * Representa una entrega parcial de productos/servicios
     */
    PARCIAL = 'parcial',
    /**
     * Representa una entrega completa de productos/servicios
     */
    RECEPTADO = 'receptado',
    RECHAZADO = 'rechazado',
}

/**
 * Representan estados de aprobación genéricos, que sean excluyentes
 * entre sí
 */
export const enum EstadoAprobacion {
    PENDIENTE = 'pendiente',
    APROBADO = 'aprobado',
    RECHAZADO = 'rechazado',
    ANULADO = 'anulado',
}

export const enum RevisionProveedor {
    SIN_REVISION = 'sin_revision',
    RECHAZADO = 'rechazado',
    APROBADO = 'aprobado',
}

export const enum EstadoItem {
    NUEVO = 'nuevo',
    USADO = 'usado',
    REMANUFACTURADO = 'remanofacturado',
}

export const enum ItemEntregado {
    SI = 'si',
    NO = 'no',
    TODOS = 'todos',
}

export const enum TipoInforme {
    DETALLADO = 'detallado',
    RESUMIDO = 'resumido',
}

export const enum MetodoPago {
    CONTADO = 'contado',
    CREDITO = 'credito',
    ANTICIPO = 'anticipo',
}

export const enum Documento {
    SOLICITUD = 'solicitud',
    COTIZACION = 'cotizacion',
    ORDEN_COMPRA = 'orden_compra',
    ORDEN_ENTREGA = 'orden_entrega',
}
